
// Utility functions for PWA detection and handling

export const isPWAInstalled = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Check for display-mode: standalone (most reliable)
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  
  // Check for iOS standalone mode
  if ('standalone' in window.navigator && (window.navigator as any).standalone) {
    return true;
  }
  
  return false;
}

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  
  return mobileRegex.test(userAgent);
}

export const isPWAOnMobile = (): boolean => {
  return isPWAInstalled() && isMobileDevice();
}

export const getDeviceType = (): 'mobile-pwa' | 'mobile-browser' | 'desktop' => {
  if (isPWAOnMobile()) {
    return 'mobile-pwa';
  }
  
  if (isMobileDevice()) {
    return 'mobile-browser';
  }
  
  return 'desktop';
}
